import { addons } from '@storybook/addons';
import phzhTheme from './theme';

addons.setConfig({
  theme: phzhTheme,
});
